import StyledTextLink from '@/atoms/Links/Text/styles';
import styled from 'styled-components';

export const StyledHardRefreshTextLink = styled(StyledTextLink).attrs({as: 'a'})``;
